module.exports = __webpack_public_path__ + "static/media/linkedin.07189f66.svg";